module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [(_vm.icon === 'search') ? _c('svg', {
    staticClass: "svg-icon icon-search",
    attrs: {
      "version": "1.1",
      "id": "icon-search",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "25 25 20 20",
      "enable-background": "new 25 25 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M37.201,26.779c3.318,0,6.02,2.701,6.02,6.021c0,3.318-2.701,6.022-6.02,6.022c-3.32,0-6.02-2.704-6.02-6.022\n            C31.181,29.48,33.881,26.779,37.201,26.779 M37.201,25.274c-4.157,0-7.526,3.369-7.526,7.525c0,4.156,3.369,7.526,7.526,7.526\n            c4.155,0,7.525-3.37,7.525-7.526C44.727,28.643,41.356,25.274,37.201,25.274L37.201,25.274z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.597,37.404c0.366,0.367,0.366,0.964,0,1.33l-5.765,5.764c-0.367,0.368-0.963,0.368-1.331,0l0,0\n            c-0.367-0.367-0.367-0.962,0-1.329l5.765-5.765C31.633,37.037,32.229,37.037,32.597,37.404L32.597,37.404z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon === 'cart') ? _c('svg', {
    staticClass: "svg-icon icon-cart",
    attrs: {
      "version": "1.1",
      "id": "icon-cart",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "1,2 1,3 2.132,3 5.585,16 18,16 18,15 6.661,15 5.896,12 16.397,12 19.313,4 3.854,4 2.896,2 "
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "5.415",
      "cy": "18.5",
      "r": "1.019"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "17.058",
      "cy": "18.5",
      "r": "1.019"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon === 'close') ? _c('svg', {
    staticClass: "svg-icon icon-close",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.071,2.929c0.391,0.391,0.391,1.023,0,1.415L4.343,17.071c-0.391,0.391-1.024,0.391-1.415,0l0,0\n        c-0.39-0.391-0.39-1.024,0-1.414L15.657,2.929C16.048,2.538,16.681,2.539,17.071,2.929L17.071,2.929z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.071,15.657c0.391,0.391,0.391,1.023,0,1.414l0,0c-0.391,0.391-1.023,0.391-1.414,0L2.929,4.343\n        c-0.39-0.391-0.39-1.024,0-1.415l0,0c0.391-0.39,1.024-0.39,1.415,0L17.071,15.657z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon === 'chevron-right') ? _c('svg', {
    staticClass: "svg-icon icon-chevron-right",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15,10.123c-0.36,0.36-8.292,8.212-8.292,8.212c-0.349,0.349-0.955,0.348-1.305,0l0,0c-0.348-0.349-0.37-0.914-0.021-1.264\n        l7.508-7.493L5.363,2.085C5.014,1.736,5.013,1.17,5.362,0.822l0,0c0.349-0.349,0.996-0.349,1.345,0c0,0,7.949,7.867,8.293,8.21\n        S15.36,9.763,15,10.123z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon === 'chevron-left') ? _c('svg', {
    staticClass: "svg-icon icon-chevron-left",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15,10.123c-0.36,0.36-8.292,8.212-8.292,8.212c-0.349,0.349-0.955,0.348-1.305,0l0,0c-0.348-0.349-0.37-0.914-0.021-1.264\n        l7.508-7.493L5.363,2.085C5.014,1.736,5.013,1.17,5.362,0.822l0,0c0.349-0.349,0.996-0.349,1.345,0c0,0,7.949,7.867,8.293,8.21\n        S15.36,9.763,15,10.123z"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03f7df6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icons.vue
// module id = 209
// module chunks = 1